import React, {Component} from "react";
import {Button, Col, Row, Form} from "react-bootstrap";
import Modal from "react-responsive-modal";
import DashboardService from "../services/DashboardService";

const MAC_LENGTH =12;

export default class FactoryResetDeviceModal extends Component {
    state = {
       mac: ""
    };

    constructor(props) {
        super(props);
        this.validateMac = this.validateMac.bind(this);
        this.alertFactoryResetDevice = this.alertFactoryResetDevice.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.factoryResetDevice = this.factoryResetDevice.bind(this);
        this.getErrorMessage = this.getErrorMessage.bind(this);
    }

    handleChange = (event) => {
        this.setState({
            mac: event.target.value   
        });
    }

    validateMac = async () => {
        const mac = this.state.mac.trim();
        if(mac.length != MAC_LENGTH) {
            alert("Enter valid mac");
            return;
        }

       await this.alertFactoryResetDevice(mac)
    }

    alertFactoryResetDevice = async (mac) => {
        const troubleshoot = window.confirm("Are you sure you want to factory reset the device with MAC "+mac+" ? ");
        if(troubleshoot) {
           await this.factoryResetDevice(mac);
        }
    };


    factoryResetDevice = async (mac) => {
        try {
            await DashboardService.factoryResetDevice(mac);
        } catch(e) {
            alert(this.getErrorMessage(e));
        } finally {
            this.setState({mac: ""})
        }
        this.props.onCloseClicked();
        this.props.onUpdate();
    }

    getErrorMessage(e) {
        console.log(JSON.stringify(e))
        if(e.response.data && e.response.data.status == 500 || e.response.data.message == undefined) {
            return "There was some error factory reset device."
        }

        return e.response.data.message
    }

  
    render() {
        return (
            <Modal open={this.props.show} onClose={this.props.onCloseClicked}>
               <h3>Factory Reset Device</h3>
                    <h5> 
                    Factory resetting a device by support is not advisable as it will set the device to a Factory Complete state. Are you sure you want to factory reset the device ?
                    </h5>
                <Row>
                <Form>
                            <Form.Group controlId="exampleForm.ControlInput1">
                                <Col sm={4}>
                                    <Form.Control required type="text" placeholder="12 character string"
                                                  onChange={this.handleChange}/>
                                    </Col>
                                </Form.Group>
                            </Form>
                                    
                </Row>
                <Row>
                    <Col sm={12}>
                    <Button variant="danger" style={{margin: 20}}
                            onClick={this.validateMac}>Proceed</Button>
                    </Col>
                </Row>
            </Modal>
        )  
               
    }
}